const formatDate = (date, options = {}) => {
  const currDate = new Date(date);

  if (options.isoFormat) {
    return `${currDate.getFullYear()}-${(currDate.getMonth() + 1).toString().padStart(2, "0")}-${currDate.getDate().toString().padStart(2, "0")}`;
  }

  const months = ["January","February","March","April","May","June","July",
    "August","September","October","November","December"];
  
  return `${months[currDate.getMonth()]} ${currDate.getDate()}, ${currDate.getFullYear()}`;
}

export { formatDate };